'use client';

import { SvgChevrondown } from '@common/icon';
import { cn } from '@core/utils';
import { useEffect, useRef, useState } from 'react';

import { SELECTOR } from '@/constants';

import SvgAi from '../_assets/ai.svg';
import styles from './AiSummary.module.scss';

interface AiSummaryProps {
  aiSummaryList: string[];
}

export const AiSummary = ({ aiSummaryList }: AiSummaryProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const ulRef = useRef<HTMLUListElement>(null);

  const [height, setHeight] = useState(0);

  useEffect(() => {
    if (location.hash === '#' + SELECTOR.COMMENT_LIST_TOP) return;

    const timer = setTimeout(() => {
      if (ulRef.current) {
        setHeight(ulRef.current.clientHeight);
      }

      setIsOpen(true);
    }, 1_000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      className={cn(
        styles['ai-summary-container'],
        'h-53 w-full rounded-xsmall transition-[height] duration-200',
        isOpen ? styles.opened : styles.closed,
      )}
      style={{ height: isOpen ? `${height + 53}px` : '53px' }}
    >
      <div
        className={cn(
          'absolute left-1 top-1 z-[2] size-[calc(100%-2px)] bg-Gray-white',
          'flex flex-col items-center rounded-xsmall',
        )}
      >
        <button
          className={cn('flex w-full items-center justify-between gap-8 p-16', {
            'pb-8': isOpen,
          })}
          type="button"
          onClick={() => {
            if (ulRef.current) {
              setHeight(ulRef.current.clientHeight);
            }

            setIsOpen(!isOpen);
          }}
        >
          <div className="flex items-center gap-8 font-600 text-Gray-black typo-body4">
            <SvgAi className="size-20" />
            정책을 요약했어요
          </div>
          <SvgChevrondown
            className={cn('size-20 text-Gray-500 transition-transform', {
              '-rotate-180': isOpen,
            })}
          />
        </button>
        <ul
          ref={ulRef}
          className={cn(
            'mr-auto flex flex-col gap-4 pb-8 pl-32 pr-16 text-Gray-800 typo-body4',
            {
              'absolute -z-10 invisible': !isOpen,
            },
          )}
        >
          {aiSummaryList.map((value, index) => {
            return (
              <li
                key={index}
                className={cn(
                  'list-disc animate-delay-75 marker:text-[0.6rem]',
                  isOpen ? 'animate-fade-right' : 'invisible',
                )}
                style={{
                  animationDuration: `${(index + 1) * 0.2}s`,
                }}
              >
                {value}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};
